import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { OfficialActMachineStateDescriptor } from './model/officialact';

@Injectable()
export class OfficialActMachineService extends RESTServiceBase {

  constructor(authService: AuthService, config: AppConfig) {
    super(
      'v1',
      'OfficialActMachineManagement',
      authService,
      config.OAMSConfig
    );
  }

  public async getExpectedStates(officialActId: string): Promise<OfficialActMachineStateDescriptor[]> {
    return super.get<OfficialActMachineStateDescriptor[]>(officialActId);
  }

  public async set(officialActId: string, state: OfficialActMachineStateDescriptor): Promise<void> {
    return super.patch<any>(officialActId, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/officialact/officialact.machine.service.ts